// 切換深淺模式按鈕
import { useTheme } from 'next-themes';

const HeaderToggleTheme = () => {
    const { setTheme, resolvedTheme } = useTheme();

    const toggleTheme = () => {
        setTheme(resolvedTheme === 'light' ? 'dark' : 'light');
    };

    return (
        <button
            onClick={toggleTheme}
            className="w-[32px] h-[32px] rounded-[50%] center-center border-1 border-[rgba(170,130,195,0.32)] trans
            hover:bg-bou hover:border-bou group ulg:hidden"
        >
            <span
                className="w-[22px] h-[22px] bg-contain bg-center trans group-hover:filter-white bg-no-repeat
            bg-[url('/images/icon/icon_light.svg')] dark:bg-[url('/images/icon/icon_dark.svg')] dark:w-[15px] dark:h-[18px] dark:translate-x-[-1px]"
            />
        </button>
    );
};

export default HeaderToggleTheme;
